import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    select: {
      flexGrow: 1,
      minWidth: "calc(50% - 10px)",
      maxWidth: "calc(50% - 10px)",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        minWidth: "100%",
        maxWidth: "100%",
        width: "100%"
      }
    },
    buttonGroup: {
      flexGrow: 1,
      minWidth: "100%",
      maxWidth: "100%"
    },
    examComment: {
      width: "100%"
    },
    textareaField: {
      "& .MuiInputBase-root": {
        color: "#2d2d2d",
        fontSize: 12
      },
      "& .MuiOutlinedInput-root fieldset": {
        borderColor: "#ccc"
      },
      "& .MuiOutlinedInput-multiline": {
        padding: "12px 9px 12px 12px"
      },
      "& .MuiOutlinedInput-root:hover fieldset": {
        borderColor: primary.main
      },
      "& .MuiOutlinedInput-root.Mui-focused fieldset": {
        borderWidth: 1,
        borderColor: secondary.dark
      }
    }
  };
});
